var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.season && _vm.wasMounted)?_c('Modal',{attrs:{"layout":"main"}},[_c('div',{staticClass:"slideshow"},[_c('MediaSlideshow',{attrs:{"images":_vm.season.posters,"index":_vm.index}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }